<template>
    <div class='change-shifts-record'>
        <el-table v-loading="isFullLoading"
            ref="elTable"
            style="width: 100%"
            :data="changeShiftsRecords"
            :height="'100%'"
            :empty-text="isFullLoading ? ' ' : '暂无数据'">
            <el-table-column
                type="index"
                label="#"
                width="50">
            </el-table-column>
            <el-table-column
                label="交班时间"
                min-width="120">
                <template v-slot="{ row }">
                    <template v-if="row.end_time != null">
                        <p>{{ row.end_time.split(' ')[0] }}</p>
                        <p>{{ row.end_time.split(' ')[1] }}</p>
                    </template>
                    <template v-else>
                        <span>-</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                label="上班时间"
                min-width="120">
                <template v-slot="{ row }">
                    <template v-if="row.start_time != null">
                        <p>{{ row.start_time && row.start_time.split(' ')[0] }}</p>
                        <p>{{ row.start_time && row.start_time.split(' ')[1] }}</p>
                    </template>
                    <template v-else>
                        <span>-</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                label="当班时长"
                min-width="140"
                align="right">
                <template v-slot="{ row }">
                    <p class="text-popper" v-textPopper>{{ getTime(row.end_time, row.start_time) }}</p>
                </template>
            </el-table-column>
            <el-table-column />
            <el-table-column
                min-width="300">
                <template v-slot:header="{ row }">
                    <span>收款金额</span>
                    <question-icon content="收款金额为当班净收款，已减去退款"/>
                </template>
                <template v-slot="{ row }">
                    <p>{{ getMoney(row) }}</p>
                </template>
            </el-table-column>
            <el-table-column
                align="right"
                min-width="100">
                <template v-slot:header="{ row }">
                    <span>收银长短款</span>
                    <question-icon :popperWidth="210">
                        <p>什么是长短款？</p>
                        <a class="color-fff href" href="http://i.senguo.cc/bbs/detail/919" target="_blank">http://i.senguo.cc/bbs/detail/919</a>
                    </question-icon>
                </template>
                <template v-slot="{ row }">
                    <p>{{ row.cashier_over_and_shorts }}</p>
                </template>
            </el-table-column>
            <el-table-column min-width="20" />
            <p v-if="isHasMore && isLoading" slot="append" style="text-align: center; padding: 10px;">
                <span class="loading-step-animation">正在加载...</span>
            </p>
            <p v-if="(!isHasMore) && changeShiftsRecords.length > 0" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
        </el-table>
    </div>
</template>

<script lang='ts'>
import { createComponent, ref, onBeforeMount, onMounted } from '@vue/composition-api'
import QuestionIcon from '@/components/question_icon/question_icon.vue'
import { useScrollLoad, openMessage } from '../../../../../utils/system'
import $fetch from '../../../../../api'
import clone from 'lodash/cloneDeep'
import { getDayBeweenDate, getSum, fixNumPro } from '../../../../../utils'
import dayjs from 'dayjs'

interface ICustomPay {
    custom_payment: {
        name: string
    }
    payment_amount: number
    refund_amount: number
    recharge_amount: number
}

export default createComponent({
    setup(props, ctx) {
        const isFullLoading = ref(false)
        const changeShiftsRecords = ref<any[]>([])
        const {
            page: oPage,
            isHasMore,
            isLoading,
            bindListener,
            initScrollLoad
        } = useScrollLoad()

        const store = ctx.root.$store
        const router = ctx.root.$router
        // const shopId = store.state.shop.shopInfo.id
        const staffId = +router.currentRoute.query.id
        const oLimit = 20

        onBeforeMount(() => {
            isFullLoading.value = true
            getChangeShiftsRecords()
                .then(() => isFullLoading.value = false)
        })

        onMounted(() => {
            bindListener({
                dom: (ctx.refs.elTable as any).$el.querySelector('.el-table__body-wrapper'),
                loadFunction: getChangeShiftsRecords
            })
        })

        async function getChangeShiftsRecords(page = oPage.value, limit = oLimit) {
            try {
                const result = await $fetch.post({
                    url: '/staff/getworkrecord',
                    params: {
                        page,
                        limit,
                        staff_id: staffId
                    }
                })
                console.log('交接班记录', clone(result))
                if (page === 1) {
                    changeShiftsRecords.value = result.work_records_list
                    initScrollLoad(result)
                } else {
                    changeShiftsRecords.value = changeShiftsRecords.value.concat(result.work_records_list)
                }
                return result
            } catch (e) {
                openMessage('error', e.message || '获取交接班记录失败')
            }
        }

        function formatDay(day: number) {
            const newDay = day.toString()
            if (newDay.length === 0) {
                return '00'
            } else if (newDay.length === 1) {
                return `0${newDay}`
            } else {
                return newDay
            }
        }

        function getTime(start: string, end: string) {
            if (start == null || end == null) {
                return '-'
            }
            const diff = getDayBeweenDate(start, end, 'millisecond')
            const diffDay = getDayBeweenDate(start, end)
            const timeResult = dayjs(diff).subtract(8, 'hour').format('HH时mm分ss秒')
            return diffDay > 0 ? `${formatDay(diffDay)}天${timeResult}` : timeResult
        }

        function getMoney(row: {
            shop: number
            staff: number
            start_time: string
            end_time: string
            payment_count: number
            recharge_count: number
            refund_count: number
            ali_payment_amount: number
            ali_recharge_amount: number
            ali_refund_amount: number
            cash_payment_amount: number
            cash_recharge_amount: number
            cash_refund_amount: number
            balance_payment_amount: number
            balance_recharge_amount: number
            balance_refund_amount: number
            wx_payment_amount: number
            wx_recharge_amount: number
            wx_refund_amount: number
            personal_ali_payment_amount: number
            personal_ali_recharge_amount: number
            personal_ali_refund_amount: number
            personal_wx_payment_amount: number
            personal_wx_recharge_amount: number
            personal_wx_refund_amount: number
            bank_card_payment_amount: number
            bank_card_recharge_amount: number
            bank_card_refund_amount: number
            custom_payments: ICustomPay[]
        }) {
            const payTypes = [{
                name: 'payment_amount',
                isAdd: true
            }, {
                name: 'recharge_amount',
                isAdd: true
            }, {
                name: 'refund_amount',
                isAdd: false
            }]
            const defaultPays = [{
                key: 'cash',
                name: '现金'
            }, {
                key: 'ali',
                name: '支付宝'
            }, {
                key: 'wx',
                name: '微信'
            }, {
                key: 'personal_ali',
                name: '个人支付宝'
            }, {
                key: 'personal_wx',
                name: '个人微信'
            }, {
                key: 'bank_card',
                name: '银行卡'
            }]
            let sum = 0
            const arr: string[] = []
            defaultPays.forEach(pay => handler(row, `${pay.key}_`, pay.name))
            row.custom_payments.forEach(customPayment => handler(customPayment, '', customPayment.custom_payment.name))
            function handler(payments: { [prop: string]: any }, payKey: string, payName: string) {
                // 求单个支付方式之和: 支付 + 充值 - 退款
                const num = payTypes.reduce((next, prev) => {
                    const payNum = payments[`${payKey}${prev.name}`]
                    if (payNum != null) {
                        next += prev.isAdd ? +payNum : -payNum
                    }
                    return next
                }, 0)
                if (num !== 0) {
                    // 如果单个支付方式不为0，则累计
                    sum += num
                    arr.push(`${payName}: ${fixNumPro(num)}`)
                }
            }
            return arr.length === 0 ? fixNumPro(sum) : `${fixNumPro(sum)} (${arr.join(' | ')})`
        }

        return {
            // data
            isHasMore,
            isLoading,
            isFullLoading,
            changeShiftsRecords,
            // methods
            getTime,
            getMoney
        }
    },
    components: {
        QuestionIcon
    }
})
</script>
